import './portfolio-immobiliare-listing.scss';

const COMPONENT_NAME = 'portfolio-immobiliare-listing';
const FILTER_BUTTONS_COMPONENT = 'portfolio-immobiliare-filter-buttons';
const FILTER_CHANGE_EVENT = `filterChange.${FILTER_BUTTONS_COMPONENT}`;
const FILTER_ALL = 'tutti';

const BEM = {
  BLOCK: COMPONENT_NAME,
  NO_RESULTS: `${COMPONENT_NAME}-no-results`,
};

const COL_POS_CLASSES = ['col-pos-1', 'col-pos-2', 'col-pos-3', 'col-pos-last-row'];

/**
 * version    1.1
 * class      PortfolioImmobiliareListing
 *
 * Gestisce il filtraggio del listing delle card immobiliari.
 * Mostra/nasconde le card in base alla categoria selezionata e fa il toggle dei blocchi "nessun risultato" "paginazione".
 *
 * I padding di colonna vengono assegnati via JS (col-pos-1/2/3) sugli article visibili,
 * in modo che nth-child non causi disallineamenti quando alcuni item sono nascosti.
 */
export class PortfolioImmobiliareListing {
  constructor() {
    this._findUIElements();
    if (!this._els.section.length) return;
    this._bindEvents();
    this._updateColumnPositions();
  }

  _findUIElements() {
    this._els = {
      section: $(`.${BEM.BLOCK}`),
      cards: $(`.${BEM.BLOCK} article[data-category]`),
      noResults: $(`.${BEM.NO_RESULTS}`),
      pagination: $('.pagination-wrapper'),
      filterButtons: $(`.${FILTER_BUTTONS_COMPONENT}`),
    };
  }

  _bindEvents() {
    this._els.filterButtons.on(FILTER_CHANGE_EVENT, (e, data) => {
      this._onFilterChange(data.filter);
    });
  }

  _onFilterChange(filter) {
    if (filter === FILTER_ALL) {
      this._els.cards.removeClass('d-none');
    } else {
      this._els.cards.each((i, card) => {
        const $card = $(card);
        const category = $card.data('category');
        $card.toggleClass('d-none', category !== filter);
      });
    }

    this._updateColumnPositions();

    const hasVisibleCards = this._els.cards.filter(':not(.d-none)').length > 0;
    this._els.noResults.toggleClass('d-none', hasVisibleCards);
    this._els.pagination.toggleClass('d-none', !hasVisibleCards);
  }

  /**
   * Assegna le classi col-pos-1/2/3 agli article visibili in base alla loro
   * posizione nella griglia, ignorando quelli nascosti con d-none.
   * Questo evita i disallineamenti che nth-child causerebbe sul filtraggio.
   */
  _updateColumnPositions() {
    const visibleCards = this._els.cards.filter(':not(.d-none)');
    const total = visibleCards.length;

    this._els.cards.removeClass(COL_POS_CLASSES.join(' '));

    visibleCards.each((i, card) => {
      const colPos = (i % 3) + 1;
      $(card).addClass(`col-pos-${colPos}`);
    });

    // Marca l'ultima riga per gestire il margin-bottom ridotto
    const lastRowStart = total - (((total - 1) % 3) + 1);
    visibleCards.slice(lastRowStart).addClass('col-pos-last-row');
  }
}
